import * as THREE from 'three';
import React, {useEffect, useMemo, useRef, useState} from 'react'
import { useFx, useSize, mix } from './fx.js'
import RenderBuffer from './render-buffer.js';
import mouseFrag from './mouse-tail-frag';
import simpleVert from './simple-vert';
import lerp from '@14islands/lerp'
function useMouseTail({materialRef}){
	const fx = useFx();
	const size = useSize();
	const { gl, frameRun } = fx
	const [material, setMaterial] = useState(false)
	const [geometry, setGeometry] = useState(false)
	const [scene, setScene] = useState(false)
	const [camera, setCamera] = useState(false)
	const [renderBuffer, setRenderBuffer] = useState(false)
	const oldScroll = useRef();
	const trailOffset = fx.trailOffset ? fx.trailOffset : 'top'
	useEffect(() => {
		const defines = {
			USE_VUV: ''
		}
		if(trailOffset === 'top'){
			defines.OFFSET_TOP = ''
		}else if(trailOffset === 'bottom'){
			defines.OFFSET_BOTTOM = ''
		}else{
			defines.OFFSET_NO = ''
		}
		const material = new THREE.ShaderMaterial({
			defines,
			vertexShader: simpleVert,
			fragmentShader: mouseFrag,
			uniforms: {
				time: {value: 0},
				fade: {value: 0},
				deltaTime: {value: 0},
				mouse: {value: new THREE.Vector2(0, 0)},
				resolution: {value: new THREE.Vector2(1, 1)},
				buffer: {value: null}, 
				isMouse: {value: false},
			}
		});
		const geometry = new THREE.PlaneGeometry( 1, 1 );
		const scene = new THREE.Scene();
		const mesh = new THREE.Mesh(geometry, material);
		scene.add(mesh);
		const camera = new THREE.OrthographicCamera(-0.5, 0.5, 0.5, -0.5, 0, 1000);
		const renderBuffer = new RenderBuffer();
		setGeometry(geometry)
		setMaterial(material)
		setScene(scene)
		setCamera(camera)
		setRenderBuffer(renderBuffer)
		return () => {
			material.dispose();
			geometry.dispose();
			renderBuffer.dispose();
		}
	}, [fx.pointer, trailOffset, gl])
	useEffect(() => {
		if(material && renderBuffer){
			material.uniforms.resolution.value.x = size.width;
			material.uniforms.resolution.value.y = size.height;
			renderBuffer.setSize(gl, size.width, size.height);
		}
	}, [size.width, size.height, material, renderBuffer, gl])
	useEffect(()=>{
		if(material && materialRef && renderBuffer && scene && camera){
			return frameRun((t)=>{
				let dt = t - material.uniforms.time.value;
				if(dt < 0){
					dt = 0
				}
				material.uniforms.deltaTime.value = dt;
				material.uniforms.time.value = t;
				const oldMx = material.uniforms.mouse.value.x;
				const oldMy = material.uniforms.mouse.value.y;
				const mx = lerp(oldMx, fx.mouse.x, 0.085, dt)
				const my = lerp(oldMy, fx.mouse.y, 0.085, dt)
				const isMouse = (
					Math.abs(oldMx - mx) > 1 / size.width ||
					Math.abs(oldMy - my) > 1 / size.height ||
					window.scrollY !== oldScroll.current
				)
				material.uniforms.mouse.value.x = mx;
				material.uniforms.mouse.value.y = my;
				material.uniforms.isMouse.value = isMouse;
				if(isMouse){
					material.uniforms.fade.value += material.uniforms.deltaTime.value * 3;
					if(material.uniforms.fade.value > 1){
						material.uniforms.fade.value = 1;
					}
				}else{
					material.uniforms.fade.value -= material.uniforms.deltaTime.value * 0.3;
					if(material.uniforms.fade.value < 0){
						material.uniforms.fade.value = 0;
					}
				}
				renderBuffer.renderTexture(gl, material, scene, camera);
				materialRef.uniforms.mouseTexture.value = renderBuffer.target.texture;
				oldScroll.current = window.scrollY;
			})
		}
	}, [frameRun, material, materialRef, renderBuffer, scene, camera, fx, gl, size.height, size.width])
}
function MouseTail(props){
	useMouseTail(props)
	return null
}
export {useMouseTail, MouseTail};
